module.exports = __webpack_public_path__ + "img/yinhai_banner.ea3e5293.jpg";